import { useCallback, useMemo, useEffect, useState } from "react";
import { getCollectionWithQuery } from "db/queries";
import { where } from "firebase/firestore";
import { useUser } from "contexts";

export const useFetchByIds = (COLLECTION_NAME, dataIds = [], converter) => {
  const [data, setData] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const { loading: userLoading } = useUser();

  const loading = useMemo(() => {
    return isLoading || userLoading || (dataIds.length && !data.length);
  }, [isLoading, userLoading, dataIds.length, data.length]);

  const fetchData = useCallback(async () => {
    if (!dataIds.length) {
      setData([]);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const chunkSize = 30;
      const chunks = [];

      for (let i = 0; i < dataIds.length; i += chunkSize) {
        chunks.push(dataIds.slice(i, i + chunkSize));
      }

      const results = await Promise.all(
        chunks.map((chunk) =>
          getCollectionWithQuery(
            COLLECTION_NAME,
            [where("__name__", "in", chunk)],
            converter
          )
        )
      );

      setData(results.flat());
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [dataIds.length]);

  useEffect(() => {
    if (dataIds.length > 0) {
      setLoading(true);
      fetchData();
    }
  }, [dataIds.length]);

  useEffect(() => {
    if (isLoading && data.length) {
      setLoading(false);
    }
  }, [isLoading, data]);

  return { data, loading, error };
};
